import React from 'react';
import Badge from '@amzn/meridian/badge';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import geopinTokens from '@amzn/meridian-tokens/base/icon/geopin';
import {useHistory, useLocation} from 'react-router-dom';

const SitesButton = () => {
  const {pathname} = useLocation();
  let history = useHistory();
  return (
    <>
      {pathname !== '/select-business' ? (
        <Button type="tertiary" size="medium" href="/sites" onClick={history.push}>
          <Icon tokens={geopinTokens}>
            <Badge />
          </Icon>
          Sites
        </Button>
      ) : null}
    </>
  );
};

export default SitesButton;
